import {ChangeDetectorRef, Component, DestroyRef, inject, Inject, OnInit, signal} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import { HttpErrorResponse } from "@angular/common/http";
import {WorkService} from "../work.service";
import { FirebaseService } from '../../services/firebase.service';
import { Status } from '../../models/status.model';

@Component({
    selector: 'app-set-status',
    templateUrl: './set-status.component.html',
    styleUrls: ['./set-status.component.scss'],
    standalone: false
})
export class SetStatusComponent implements OnInit {
  statuses = signal<Status[]>(undefined);
  done = signal(false);
  working = signal(false);
  destroyRef = inject(DestroyRef);
  
  constructor(
    private dialogRef: MatDialogRef<SetStatusComponent>,
    private firebase: FirebaseService,
    private workService: WorkService,
    @Inject(MAT_DIALOG_DATA) private data,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit() {
    this.firebase.subscribeToMessages('status-change',{
      id: this.data.document_id,
      type: this.data.document_type,
    },(data) => {
      if (data) {
        this.cdr.markForCheck();
        this.statuses.set(data.extra);
      }
    }, this.destroyRef);
  }
  setStatus(status){
    if(status){
      this.cdr.markForCheck();
      this.working.set(true);
      this.workService.updateStatus(this.data.work_instance_id, { status_id: status.id }).toPromise().then((response) => {
        this.cdr.markForCheck();
        this.done.set(true);
        this.working.set(false);
        setTimeout(()=>{
          this.dialogRef.close();
        },2000);
      }).catch((error:HttpErrorResponse) => {
        this.cdr.markForCheck();
        console.log(error);
        this.working.set(false);
      });
    }else{
      this.dialogRef.close();
    }
  }
}
